module.exports = {
    title: "Resume Template",
    crud: {
        create: "Create Resume Template Plan",
        edit: "Edit Resume Template Plan",
        view: "View Resume Template Plan",
    },
    table: {
        templateImage:'Template',
        title:'Title',
        platform:'Platform',
        userType:'User Type',
        skuCodeAndroid:'SKU Code Android',
        skuCodeIos:'SKU Code IOS',
        color: "Color",
        fontStyle: "Font Style",
        fontSize: "Font Size",
        isFree: "Is Free",
        createdAt:'Created At',
        action: "Action",
    },
    form: {
        type: "Type",
        skuCodeAndroid:'SKU Code Android',
        skuCodeIos:'SKU Code IOS',
        title: "Title",
        sequence: "Sequence",
        name: "Name",
        color: "Color",
        fontStyle: "Font Style",
        fontSize: "Font Size",
        description: "Description",
        platform: "Platform",
        price: "Price",
        offerPrice: "Offer Price",
        country: "Country",
        isFree: "Is Free",
    },
    validation: {
        required: {
            title: 'Title is required',
            type: 'Type is required',
            skuId:'SKU ID is required',
            description: 'Description is required',
            platform: 'Platform is required',
            fontStyle:"font style is required",
            fontSize:"Font size is required",
            color:"Color is required",
            country: "Country is required"
        }
    },
}
